export const content = {
    orders: {
        title: 'Manajemen Pesanan',
        orderNumber: 'No. Pesanan',
        customer: 'Pelanggan',
        product: 'Produk',
        quantity: 'Jumlah',
        price: 'Harga',
        shippingCost: 'Ongkir',
        paymentMethod: 'Metode Pembayaran',
        shippingMethod: 'Metode Pengiriman',
        orderDate: 'Tanggal Pesanan',
        pending: 'Pending',
        processing: 'Diproses',
        shipped: 'Dikirim',
        delivered: 'Terkirim',
        canceled: 'Dibatalkan',
        pendingDeletion: 'Menunggu Penghapusan',
        filterByStatus: 'Filter Status',
        filterByBrand: 'Filter Brand',
        filterByDate: 'Filter Tanggal',
        whatsappConfirm: 'Konfirmasi via WhatsApp',
        deleteOrder: 'Hapus Pesanan',
        confirmDelete: 'Apakah Anda yakin ingin menghapus pesanan ini?',
    },
    customers: {
        title: 'Manajemen Pelanggan',
        addCustomer: 'Tambah Pelanggan',
        editCustomer: 'Edit Pelanggan',
        customerName: 'Nama Pelanggan',
        totalSpent: 'Total Belanja',
        orderCount: 'Jumlah Pesanan',
        lastOrder: 'Pesanan Terakhir',
        customerScore: 'Skor Pelanggan',
        viewOrders: 'Lihat Pesanan',
    },
    forms: {
        title: 'Formulir',
        createForm: 'Buat Formulir',
        editForm: 'Edit Formulir',
        formName: 'Nama Formulir',
        productName: 'Nama Produk',
        productPrice: 'Harga Produk',
        productImage: 'Gambar Produk',
        productDescription: 'Deskripsi Produk',
        viewForm: 'Lihat Formulir',
        copyLink: 'Salin Link',
        linkCopied: 'Link disalin!',
        deleteForm: 'Hapus Formulir',
        duplicateForm: 'Duplikat Formulir',
    },
    abandonedCarts: {
        title: 'Keranjang Ditinggalkan',
        customerInfo: 'Info Pelanggan',
        cartItems: 'Isi Keranjang',
        abandonedAt: 'Ditinggalkan',
        followUp: 'Follow Up',
        contacted: 'Sudah Dihubungi',
        markContacted: 'Tandai Dihubungi',
    },
};
